import React, { useContext } from "react";
import { useHistory } from "react-router-dom";

import {
  Breadcrumb,
  HyphenIcon,
  Toolbar,
} from "@transfr-inc/dashboard-components";
import { Button } from "@transfr-inc/dashboard-components/forms";
import { PageHeader } from "@transfr-inc/dashboard-components/layouts";

import "./program-detail.header.scss";
import { getRoleFeatures } from "../../../../../constants/role";
import { SessionContext } from "../../../../../context/session.context";

export const ProgramDetailPageHeader = ({
  data,
  breadcrumb,
  credentials,
  onEditProgramDetails,
  handleDelete,
}) => {
  const { goBack } = useHistory();

  const programEditable = true;
  const certificateName = credentials?.accredibleInfo?.displayName;
  const { role } = useContext(SessionContext);

  const roleFeatures = getRoleFeatures(role);

  const subtitle = (
    <ul className="metadata">
      <li>Certificate: {certificateName ?? "None"}</li>
      <li>{data?.description || "No description."}</li>
    </ul>
  );

  const toolbar = (
    <Toolbar>
      {roleFeatures?.canEditProgram && (
        <Button
          icon={["fa-regular", "pen-to-square"]}
          title={"Edit Menu"}
          onClick={onEditProgramDetails}
        />
      )}
      {roleFeatures?.canDeleteProgramCourse && (
        <Button
          icon={["fa-regular", "trash-can"]}
          title={"Delete Menu"}
          onClick={() => handleDelete("program", data.id, data.title)}
        />
      )}
    </Toolbar>
  );

  return (
    <>
      <PageHeader
        title={data?.title || <HyphenIcon />}
        subTitle={subtitle}
        breadcrumb={<Breadcrumb onClick={goBack} label={breadcrumb} />}
        drawerColorEnabled
        className={"detail"}
      >
        {programEditable && toolbar}
      </PageHeader>
    </>
  );
};
